import React from 'react';
import PropTypes from 'prop-types';
import { AdminHeader } from '../components/AdminHeader';

const AdminLayout = ({ children, username, email, onLogout }) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <AdminHeader
        username={username}
        email={email}
        onLogout={onLogout}
      />
      <main className="flex-1 pt-[80px]">
        {children}
      </main>
    </div>
  );
};

AdminLayout.propTypes = {
  children: PropTypes.node.isRequired,
  username: PropTypes.string.isRequired,
  email: PropTypes.string,
  onLogout: PropTypes.func.isRequired,
};

export default AdminLayout;
